<dx-button
  [type]="type"
  [text]="label"
  (click)="click.emit(action)"
  [icon]="icon"
  [disabled]="isDisabled"
  [title]="title"
></dx-button>
